import { extractProps } from '@famly/mf_ts-utils_extract-props';
export const extractAriaProps = (props) => {
    return extractProps(props, 'aria');
};
